import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { Container, PageHeader } from "../components/ui-kit";
import { CONTACT } from "../mock";

const SECTIONS = [
  {
    h: "1. Veri Sorumlusu",
    p: [
      "Bu gizlilik politikası, Koşan Düğme İmalat San. ve Tic. Ltd. Şti. (\"Koşan Düğme\") tarafından işletilen web sitesi için geçerlidir. 6698 sayılı Kişisel Verilerin Korunması Kanunu (\"KVKK\") kapsamında veri sorumlusu Koşan Düğme'dir.",
    ],
  },
  {
    h: "2. Toplanan Veriler",
    p: [
      "Sitemizdeki iletişim formu, teklif sepeti ve bülten aboneliği aracılığıyla; ad soyad, firma adı, e-posta adresi, telefon numarası ve ilettiğiniz mesaj/talep bilgileri tarafımıza iletilir. Bu veriler yalnızca sizin talebiniz üzerine, tarafınızdan sağlanır.",
    ],
  },
  {
    h: "3. Verilerin İşlenme Amacı",
    p: [
      "Toplanan veriler; talep ettiğiniz teklif ve numune süreçlerini yürütmek, sorularınızı yanıtlamak, siparişlerinizi yönetmek ve onay verdiğiniz durumlarda ürün/kampanya duyuruları göndermek amacıyla işlenir.",
    ],
  },
  {
    h: "4. Çerezler ve Analitik",
    p: [
      "Sitemiz, kullanıcı deneyimini iyileştirmek ve ziyaret istatistiklerini anonim olarak ölçmek için çerezler ve analitik araçlar kullanabilir. Tarayıcı ayarlarınızdan çerezleri dilediğiniz zaman yönetebilir veya engelleyebilirsiniz.",
    ],
  },
  {
    h: "5. Verilerin Paylaşımı",
    p: [
      "Kişisel verileriniz üçüncü kişilerle pazarlama amacıyla paylaşılmaz. Veriler yalnızca yasal yükümlülükler ve talebinizin yerine getirilmesi için gerekli olduğu ölçüde işlenir ve saklanır.",
    ],
  },
  {
    h: "6. Haklarınız",
    p: [
      "KVKK kapsamında; verilerinize erişme, düzeltilmesini veya silinmesini talep etme ve işlenmesine itiraz etme haklarına sahipsiniz. Taleplerinizi aşağıdaki iletişim kanallarından bize iletebilirsiniz.",
    ],
  },
];

const Privacy = () => (
  <main className="bg-canvas" data-testid="privacy-page">
    <Seo
      title="Gizlilik Politikası — Koşan Düğme"
      description="Koşan Düğme web sitesi gizlilik politikası ve KVKK kapsamında kişisel verilerin işlenmesine ilişkin aydınlatma metni."
      path="/gizlilik"
    />
    <Breadcrumbs items={[{ label: "Gizlilik Politikası", to: "/gizlilik" }]} />
    <PageHeader
      eyebrow="Yasal"
      title="Gizlilik Politikası"
      text="Kişisel verilerinizin gizliliği bizim için önemlidir. Bu metin, verilerinizin nasıl toplandığını ve işlendiğini açıklar."
    />
    <Container className="py-16 lg:py-20 max-w-3xl">
      <div className="space-y-10">
        {SECTIONS.map((s) => (
          <section key={s.h} data-testid="privacy-section">
            <h2 className="font-display font-light text-2xl text-ink">{s.h}</h2>
            {s.p.map((t, i) => (
              <p key={i} className="text-ink2 leading-relaxed mt-4 text-[15px]">{t}</p>
            ))}
          </section>
        ))}
        <section className="bg-paper border border-line p-7">
          <h2 className="font-display font-light text-2xl text-ink">İletişim</h2>
          <p className="text-ink2 leading-relaxed mt-4 text-[15px]">
            Sorularınız ve talepleriniz için: <br />
            E-posta: <a href={`mailto:${CONTACT.emails[0]}`} className="text-ink font-medium hover:text-brand transition-colors">{CONTACT.emails[0]}</a>
            <br />
            Telefon: <a href={CONTACT.phoneHref} className="text-ink font-medium hover:text-brand transition-colors">{CONTACT.phone}</a>
            <br />
            Adres: {CONTACT.address}
          </p>
        </section>
      </div>
    </Container>
  </main>
);

export default Privacy;
